import { render } from "./NavbarPublicAgahi.vue?vue&type=template&id=7543081d&scoped=true"
const script = {}

import "./NavbarPublicAgahi.vue?vue&type=style&index=0&id=7543081d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7543081d"]])

export default __exports__